import axios from "axios";
import { BASEURL } from "../Api/Api";
export const postMethod = async (url, params) => {
  try {
    const response = await axios.post(BASEURL + url, params);
    return response.data;
  } catch (error) {
    console.error("Failed to post data:", error);
    throw error;
  }
};
export const postMethodFormFilling = async (url, params) => {
  try {
    const response = await axios.post(BASEURL + url, params);
    console.log("Full Axios Response:", response);
    return response;
  } catch (error) {
    console.error("Axios Error:", error);
    throw error;
  }
};
// GET Method
export const getMethod = async (url, params) => {
  try {
    const response = await axios.get(BASEURL + url, { params });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch data:", error);
    throw error;
  }
};
export const getMethodserach = async (url, params) => {
  try {
    const response = await axios.get(url, { params }); // Axios GET request with query params
    return response; // Return full response, or modify based on need
  } catch (error) {
    console.error("Error with GET request:", error.message);
    throw error;
  }
};

export const putMethod = async (url, params) => {
  try {
    const response = await axios.put(BASEURL + url, params);
    return response.data;
  } catch (error) {
    console.error("Failed to update data:", error);
  }
};

// DELETE Method
export const deleteMethod = async (url) => {
  try {
    const response = await axios.delete(BASEURL + url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
